module.exports = __webpack_public_path__ + "static/media/Krithika.69c42ad4.webp";